<template>
  <div class>
    <toptitle :title="topTitle" :subtitle="topSubTitle"></toptitle>
    <div class="products-container">
      <div class="container">
        <div class="row d-flex">
          <leftsidebar class="order-md-1 order-2"></leftsidebar>
          <div class="products-box col-md-9 order-md-2 order-1">
            <div class="products-title">
              <span v-if="currentLanguage == 'CN'">全部产品</span>
              <span v-else-if="currentLanguage == 'EN'">All Product</span>
              <span v-else-if="currentLanguage == 'JP'">すべての製品</span>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="products-nav">
                  <a
                    href="javascript:;"
                    v-on:click="change(index)"
                    :class='currentIndex==index?"products-nav-active":""'
                    class="products-nav-link"
                    v-for="(item, index) in productsData"
                    :key="index"
                  >{{item.name}}</a>
                </div>
              </div>
            </div>
            <div
              class="row"
              v-for="(data, index) in productsData"
              :key="index"
              :class='currentIndex==index?"":"d-none"'
            >
              <div
                class="col-6 col-md-3 products-items"
                v-for="(items, index) in data.productsList"
                :key="index"
              >
                <router-link
                  tag="a"
                  :to="`/productscontent/${items._id}`"
                  class="products-link"
                  href="javascript:;"
                >
                  <div class="products-img">
                    <img :src="items.image[0].url" :alt="items.name" />
                  </div>
                  <div class="products-text">
                    <p class="products-text-name">{{ items.name }}</p>
                    <p class="products-text-model">{{ items.number }}</p>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import productslistCN from '../data/CN/productslist_CN.json'
import productslistEN from '../data/EN/productslist_EN.json'
import productslistJP from '../data/JP/productslist_JP.json'
export default {
  data() {
    return {
      currentIndex: 0,
      topTitle: '产品中心',
      topSubTitle: '专业光学自动化设备，实力见证品牌',
      productsData: [],
      currentLanguage: '' // 当前语言
    }
  },
  mounted() {
      const _this = this
      window.addEventListener('setItemEvent', function(e) {
          // e.key : 是值发生变化的key
          // 例如 e.key==="token";
          // e.newValue : 是可以对应的新值
          if (e.key === 'language') {
              var d = e.newValue
            _this.currentLanguage = e.newValue
              if (d === 'CN') {
                  _this.productsData = productslistCN
              } else if (d === 'EN') {
                  _this.productsData = productslistEN
              } else if (d === 'JP') {
                  _this.productsData = productslistJP
              }
          }
      })
  },
  methods: {
    change: function(index) {
      // 在这里实现选项卡切换操作：本质就是操作类名
      // 如何操作类名？就是通过currentIndex
      this.currentIndex = index
    },
    // 查询所有的产品
    findProductsData: function() {
      var lg = localStorage.getItem('language')
      this.currentLanguage = lg
      if (lg === 'CN') {
          this.productsData = productslistCN
      } else if (lg === 'EN') {
          this.productsData = productslistEN
      } else if (lg === 'JP') {
          this.productsData = productslistJP
      }
    }
  },
  created() {
    this.findProductsData()
  }
}
</script>
<style scoped>
.products-container {
  padding: 30px 0;
}
.products-box {
  margin-bottom: 26px;
}
.products-title {
  border-bottom: 1px solid #cccccc;
  margin-bottom: 6px;
}
.products-title span {
  display: inline-block;
  font-size: 22px;
  padding: 4px 0;
  position: relative;
  bottom: -1px;
  border-bottom: 1px solid #048bd4;
  color: #048bd4;
}

@media (max-width: 768px) {
  .products-items {
    margin-top: 20px;
  }
  .products-nav-link {
    margin-bottom: 20px;
  }
}

.products-items {
  margin-top: 30px;
}

.products-link {
  display: block;
  border: 1px solid #e8e8e8;
  transition: border 0.3s ease;
  transition: box-shadow 0.3s ease;
}

.products-link:hover {
  border-color: #048bd4;
  color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.products-link:hover .products-text-model {
  color: #fff;
}

.products-link:hover .products-text {
  background-color: #048bd4;
}
.products-link:hover .products-img img {
  transform: scale(1.1);
}

.products-img {
  overflow: hidden;
  text-align: center;
  height: 224px;
  /* padding: 20px 30px; */
}
.products-img img {
  width: 100%;
  transition: all 0.3s ease;
}
.products-text {
  text-align: center;
  padding: 10px;
  background-color: #e8e8e8;
  transition: background 0.3s ease;
}

.products-text-name {
  font-size: 14px;
  line-height: 24px;
}
.products-text-model {
  font-size: 12px;
  color: #666;
}
.products-nav {
  margin-top: 20px;
}
.products-nav-link {
  display: inline-block;
  padding: 6px 14px;
  color: #666;
  background: #e8e8e8;
  margin-right: 10px;
}
.products-nav-link:hover {
  color: #fff;
  background: #048bd4;
}
.products-nav-active {
  color: #fff;
  background: #048bd4;
}
</style>